// services/features/invitationService.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";
import { 
    Invitation, 
    InvitationListResponse, 
    CreateInvitationRequest, 
    CreateInvitationResponse,
    ResendEmailResponse,
    RegenerateLinkResponse 
} from "../types/features/Invitation";

export const invitationService = {
    // Liste des invitations
    async getInvitations(
        token: string, 
        page: number = 1, 
        perPage: number = 20,
        status?: string,
        search?: string
    ): Promise<InvitationListResponse> {
        const response = await axios.get<InvitationListResponse>(`${MAIN_API_URL}/invitations`, {
            params: { 
                page, 
                per_page: perPage,
                status,
                search 
            },
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    },

    // Créer une invitation
    async createInvitation(
        token: string, 
        data: CreateInvitationRequest
    ): Promise<CreateInvitationResponse> {
        const response = await axios.post<CreateInvitationResponse>(
            `${MAIN_API_URL}/invitations`, 
            data,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Renvoyer l'email d'invitation
    async resendEmail(token: string, id: string): Promise<ResendEmailResponse> {
        const response = await axios.post<ResendEmailResponse>(
            `${MAIN_API_URL}/invitations/${id}/resend-email`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Régénérer le lien court
    async regenerateLink(token: string, id: string): Promise<RegenerateLinkResponse> {
        const response = await axios.post<RegenerateLinkResponse>(
            `${MAIN_API_URL}/invitations/${id}/regenerate-link`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    },

    // Supprimer une invitation
    async deleteInvitation(token: string, id: string): Promise<void> {
        await axios.delete(`${MAIN_API_URL}/invitations/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    },

    // Redirection par lien court (public)
    getShortLink(code: string): string {
        return `${window.location.origin}/i/${code}`;
    },
};